export default "__VITE_ASSET__DUo0X8EE__"